import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { logger } from '../utility/logger'

export default defineNuxtRouteMiddleware((to) => {
  // Only run on server-side and for HTML requests
  if (
    process.server &&
    to.path !== '/' &&
    // no trailing slash
    !to.path.endsWith('/') &&
    // no api routes
    !to.path.includes('/api') &&
    !to.path.startsWith('/api') &&
    // no static files (files with extensions)
    !to.path.includes('.') &&
    // don't redirect if query string is already in the path
    !to.path.includes('?') &&
    // don't redirect if hash is already in the path
    !to.path.includes('#') &&
    // don't redirect special routes
    !to.path.startsWith('/_') &&
    !to.path.startsWith('/complete/') &&
    !to.path.startsWith('/cdn-cgi/') &&
    !to.path.startsWith('/gtm.js') &&
    !to.path.startsWith('/mapbox/') &&
    !to.path.startsWith('/images/')
  ) {
    logger('trailingSlash middleware executing redirect for:', to.fullPath)
    return navigateTo(
      {
        path: `${to.path}/`,
        query: to.query,
        hash: to.hash,
      },
      { redirectCode: 301 },
    )
  }
})
